import { IAnalyticsFilterStateRepository } from "@/core/repositories/analyticsFilterState";

export class ResetAnalyticsFilterStateUseCase {
  constructor(private readonly repository: IAnalyticsFilterStateRepository) {}

  async execute(): Promise<void> {
    await this.repository.resetAnalyticsFilterState();
  }
}
